import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"
import {
  ICreateThrottleConfigInput,
  IUpdateThrottleConfigInput,
} from "@/models/throttleConfig/throttleConfig.types"
import {
  BackofficeRestMutations,
  UpdateThrottleConfigPayload,
} from "@/api/backofficeRest/mutations"
import { CreateThrottleConfigBody } from "@/api/backofficeRest/generated/model"

export class EmailThrottleMutatorClass {
  createConfig(
    onSuccessFn?: () => void,
  ): MutationResult<ICreateThrottleConfigInput> {
    return useMutation({
      ...BackofficeRestMutations.throttle.createConfig(),
      serializerFn: (input): CreateThrottleConfigBody => ({
        communicationId: input.communicationId,
        maxPerWindow: input.maxPerWindow,
        windowSeconds: input.windowSeconds,
      }),
      onSuccessFn,
    })
  }

  updateConfig(
    onSuccessFn?: () => void,
  ): MutationResult<IUpdateThrottleConfigInput> {
    return useMutation({
      ...BackofficeRestMutations.throttle.updateConfig(),
      serializerFn: (input): UpdateThrottleConfigPayload => ({
        id: input.id,
        maxPerWindow: input.maxPerWindow,
        windowSeconds: input.windowSeconds,
        enabled: input.enabled,
      }),
      onSuccessFn,
    })
  }

  resumeEvent(onSuccessFn?: () => void): MutationResult<number> {
    return useMutation({
      ...BackofficeRestMutations.throttle.resumeEvent(),
      serializerFn: (v) => v,
      onSuccessFn,
    })
  }

  discardEvent(onSuccessFn?: () => void): MutationResult<number> {
    return useMutation({
      ...BackofficeRestMutations.throttle.discardEvent(),
      serializerFn: (v) => v,
      onSuccessFn,
    })
  }
}

export const EmailThrottleMutator = new EmailThrottleMutatorClass()
